import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const MultiBrandPortfolio = () => {
  const brands = [
  {
    id: 1,
    name: 'Dog Chow',
    description: 'Marca líder en nutrición diaria para perros adultos.',
    image: '/assets/images/brands/dog-chow.png'
  },
  {
    id: 2,
    name: 'Cat Chow',
    description: 'Nutrición completa y balanceada para gatos de todas las edades.',
    image: '/assets/images/brands/cat-chow.png'
  },
  {
    id: 3,
    name: 'Dogourmet',
    description: 'Alimento premium con ingredientes seleccionados para perros exigentes.',
    image: '/assets/images/brands/dogourmet.png'
  },
  {
    id: 4,
    name: 'Oh My Cat',
    description: 'Nutrición especializada para el bienestar felino.',
    image: '/assets/images/brands/oh-my-cat.png'
  },
  {
    id: 5,
    name: 'Donkan',
    description: 'Alimento económico de calidad para perros de todas las razas.',
    image: '/assets/images/brands/donkan.png'
  },
  {
    id: 6,
    name: 'Donkat',
    description: 'Nutrición accesible y balanceada para gatos.',
    image: '/assets/images/brands/donkat.png'
  },
  {
    id: 7,
    name: 'Ringo',
    description: 'Marca tradicional colombiana para perros adultos.',
    image: '/assets/images/brands/ringo.png'
  },
  {
    id: 8,
    name: 'Mirringo',
    description: 'Alimento colombiano de confianza para gatos.',
    image: '/assets/images/brands/mirringo.png'
  },
  {
    id: 9,
    name: 'Chunky',
    description: 'Nutrición completa para perros con excelente relación calidad-precio.',
    image: '/assets/images/brands/chunky.png'
  },
  {
    id: 10,
    name: 'Agility',
    description: 'Alimento premium para perros activos y deportivos.',
    image: '/assets/images/brands/agility.png'
  },
  {
    id: 11,
    name: '7 Vidas',
    description: 'Nutrición especializada para gatos con ingredientes naturales.',
    image: '/assets/images/brands/7-vidas.png'
  },
  {
    id: 12,
    name: 'BR Dog',
    description: 'Alimento balanceado para perros de todas las edades.',
    image: '/assets/images/brands/br-dog.png'
  },
  {
    id: 13,
    name: 'BR Cat',
    description: 'Nutrición completa para gatos adultos y cachorros.',
    image: '/assets/images/brands/br-cat.png'
  },
  {
    id: 14,
    name: 'Nutre Can',
    description: 'Alimento nutritivo para perros con ingredientes de calidad.',
    image: '/assets/images/brands/nutre-can.png'
  },
  {
    id: 15,
    name: 'Nutre Cat',
    description: 'Nutrición balanceada para gatos de todas las razas.',
    image: '/assets/images/brands/nutre-cat.png'
  },
  {
    id: 16,
    name: 'Felix',
    description: 'Marca internacional reconocida por su calidad en nutrición felina.',
    image: '/assets/images/brands/felix.png'
  },
  {
    id: 17,
    name: 'Gatsy',
    description: 'Alimento para gatos con control de bolas de pelo.',
    image: '/assets/images/brands/gatsy.png'
  },
  {
    id: 18,
    name: 'Apa',
    description: 'Nutrición económica y confiable para perros.',
    image: '/assets/images/brands/apa.png'
  },
  {
    id: 19,
    name: 'Italcan',
    description: 'Alimento húmedo premium para perros y gatos.',
    image: '/assets/images/brands/italcan.png'
  },
  {
    id: 20,
    name: 'Calabaza Pets',
    description: 'Snacks y premios naturales para mascotas.',
    image: '/assets/images/brands/calabaza-pets.png'
  }];


  return (
    <section data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:129:4" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="129" data-component-end-line="173" data-component-file="MultiBrandPortfolio.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22lg%3Apy-24%20bg-surface%20py-%5B50px%5D%22%7D" className="lg:py-24 bg-surface py-[50px]">
      <div data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:130:6" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="130" data-component-end-line="172" data-component-file="MultiBrandPortfolio.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20lg%3Apx-6%22%7D" className="max-w-7xl mx-auto px-4 lg:px-6">
        <div data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:131:8" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="131" data-component-end-line="144" data-component-file="MultiBrandPortfolio.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-12%22%7D" className="text-center mb-12">
          <div data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:132:10" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="132" data-component-end-line="137" data-component-file="MultiBrandPortfolio.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22inline-flex%20items-center%20gap-2%20px-3%20py-1.5%20bg-accent%2F10%20rounded-full%20mb-4%22%7D" className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent/10 rounded-full mb-4">
            <Icon data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:133:12" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="133" data-component-end-line="133" data-component-file="MultiBrandPortfolio.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22BuildingStorefrontIcon%22%2C%22className%22%3A%22text-accent%22%7D" name="BuildingStorefrontIcon" size={16} variant="solid" className="text-accent" />
            <span data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:134:12" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="134" data-component-end-line="136" data-component-file="MultiBrandPortfolio.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-roboto%20text-sm%20font-medium%20text-accent%22%2C%22textContent%22%3A%22Portafolio%20Multimarca%22%7D" className="font-roboto text-sm font-medium text-accent">
              Portafolio Multimarca
            </span>
          </div>
          <h2 data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:138:10" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="138" data-component-end-line="140" data-component-file="MultiBrandPortfolio.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-rego%20text-3xl%20lg%3Atext-4xl%20font-bold%20text-text-primary%20mb-4%22%2C%22textContent%22%3A%22Marcas%20L%C3%ADderes%20del%20Mercado%22%7D" className="font-rego text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Marcas Líderes del Mercado
          </h2>
          <p data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:141:10" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="141" data-component-end-line="143" data-component-file="MultiBrandPortfolio.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-roboto%20text-lg%20text-text-secondary%20max-w-3xl%20mx-auto%22%2C%22textContent%22%3A%22Distribuidor%20autorizado%20de%20las%20principales%20marcas%20de%20nutrici%C3%B3n%20animal%20en%20Colombia.%20Amplitud%20de%20portafolio%2C%20respaldo%20comercial%20y%20rotaci%C3%B3n%20garantizada.%22%7D" className="font-roboto text-lg text-text-secondary max-w-3xl mx-auto">
            Distribuidor autorizado de las principales marcas de nutrición animal en Colombia. Amplitud de portafolio, respaldo comercial y rotación garantizada.
          </p>
        </div>

        <div data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:146:8" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="146" data-component-end-line="171" data-component-file="MultiBrandPortfolio.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {brands?.map((brand) =>
          <div data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:148:10" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="148" data-component-end-line="169" data-component-file="MultiBrandPortfolio.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-lg%20p-6%20border%20border-border%20hover%3Aborder-accent%20transition-all%20duration-300%20hover%3Ashadow-md%22%7D"
            key={brand?.id}
            className="bg-card rounded-lg p-6 border border-border hover:border-accent transition-all duration-300 hover:shadow-md">

              <div data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:152:14" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="152" data-component-end-line="165" data-component-file="MultiBrandPortfolio.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-3%20mb-3%22%7D" className="flex items-center gap-3 mb-3">
                <div data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:153:16" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="153" data-component-end-line="161" data-component-file="MultiBrandPortfolio.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-12%20h-12%20bg-surface%20rounded-lg%20flex%20items-center%20justify-center%20flex-shrink-0%20overflow-hidden%22%7D" className="w-12 h-12 bg-surface rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden">
                  <AppImage data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:154:18" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="154" data-component-end-line="159" data-component-file="MultiBrandPortfolio.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22object-contain%22%7D"
                  src={brand?.image}
                  alt={brand?.name}
                  width={48}
                  height={48}
                  className="object-contain" />

                </div>
                <h3 data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:162:16" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="162" data-component-end-line="164" data-component-file="MultiBrandPortfolio.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-rego%20text-lg%20font-bold%20text-text-primary%22%7D" className="font-rego text-lg font-bold text-text-primary">
                  {brand?.name}
                </h3>
              </div>
              <p data-component-id="src/app/products/components/MultiBrandPortfolio.tsx:166:14" data-component-path="src/app/products/components/MultiBrandPortfolio.tsx" data-component-line="166" data-component-end-line="168" data-component-file="MultiBrandPortfolio.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-roboto%20text-sm%20text-text-secondary%22%7D" className="font-roboto text-sm text-text-secondary">
                {brand?.description}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default MultiBrandPortfolio;